module.exports = "<div class=\"cont\" *ngFor=\"let paragraph of paragraphs\">\n\n\n<div class=\"columns\" >\n  <div class=\"column\">\n    <textarea [(ngModel)]=\"paragraph.content\" class=\"textarea\" value=\"{{paragraph.content}}\"></textarea>\n  </div>\n</div>\n  <div class=\"columns\">\n\n<button class=\"button is-primary\" (click)=\"this.update(paragraph)\">Submit</button>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/body-editer/body-editer.component.html
// module id = ./src/app/components/body-editer/body-editer.component.html
// module chunks = main